RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const MIN_EXPLANATION_LENGTH = 2;

    const AreYouSureView = Marionette.ItemView.extend({
        template: '#accountSettingsChurnModalAreYouSure'
    });

    const TellUsWhyView = Marionette.ItemView.extend({
        className: 'tell-us-why-container',
        template: '#accountSettingsChurnModalTellUsWhy',

        ui: {
            followUpForm: '.x-follow-up-form',
            followUpQuestion: '.x-follow-up-question',
            reasons: 'input[type="radio"]',
            explanation: 'textarea'
        },

        eventsNotToDebounce: {
            'change @ui.reasons': 'onReasonSelect',
            'input @ui.explanation': 'onExplanationInput',
            'focus @ui.explanation': 'enableNextButton'
        },

        getChurnReasons: function () {
            const me = this;
            const churnReasons = App.data.churnReasons.toJSON();

            if (!me.model.get('isAgency')) {
                // remove 'I lost my client' reason
                _.remove(churnReasons, {
                    id: 6
                });
            }

            // other should always be last
            const other = _.remove(churnReasons, {
                reason: 'Other'
            });
            return _.shuffle(churnReasons).concat(other);
        },

        templateHelpers: function () {
            const me = this;
            return {
                churnReasons: me.getChurnReasons()
            };
        },

        onReasonSelect: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            const reasonId = parseInt($el.attr('value'));
            const reasonIndx = _.findIndex(me.ui.reasons, function (reason) {
                return reason.id === $el.attr('id');
            });
            const formAttrs = me.model.get('formAttrs') || {};
            me.model.set({
                formAttrs: _.extend(formAttrs, {
                    churn_reason_id: reasonId,
                    reason_index: reasonIndx
                })
            });
            me.showFollowUp(reasonId);
        },

        showFollowUp: function (reasonId) {
            const me = this;
            const churnReason = App.data.churnReasons.find({
                id: reasonId
            });
            me.ui.followUpForm.removeClass('display-none');
            me.ui.followUpQuestion.text(churnReason.get('follow_up_question'));
        },

        onExplanationInput: function (e) {
            const me = this;
            const input = $(e.currentTarget).val();
            const whitespaceRemovedInput = input.replace(/\s+/g, '');
            if (input && whitespaceRemovedInput.length >= MIN_EXPLANATION_LENGTH) {
                me._parentLayoutView().ui.nextBtn.removeClass('disabled');
                const formAttrs = me.model.get('formAttrs') || {};
                me.model.set({
                    formAttrs: _.extend(formAttrs, {
                        explanation: input
                    })
                });
            } else {
                me._parentLayoutView().ui.nextBtn.addClass('disabled');
            }
        }
    });

    views.ChurnModal = Marionette.LayoutView.extend({
        template: '#accountSettingsChurnModal',
        className: 'modal churn-modal',
        attributes: {
            tabindex: -1
        },

        regions: {
            body: '.x-body'
        },

        ui: {
            nextBtn: '.x-next',
            churnReason: '.x-reason-select',
            explanation: '.x-reason-explanation'
        },

        events: {
            'click @ui.nextBtn': 'nextScreen'
        },

        behaviors: {
            FormValidator: {}
        },

        onBeforeShow: function () {
            const me = this;
            me.body.show(new AreYouSureView({
                model: me.model
            }));

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.OpenedChurnModal);

            $.post('/api/triggers', {
                type: 'email',
                trigger_type: 'viewed_churn_modal'
            });
        },

        nextScreen: function () {
            const me = this;
            if (me.body.currentView instanceof AreYouSureView) {
                me.body.show(new TellUsWhyView({
                    model: me.model
                }));
                me.ui.nextBtn.text('Confirm Cancellation');
                me.ui.nextBtn.addClass('disabled');
            } else {
                // cancel time
                me.cancelPlan();
            }
        },

        cancelPlan: function () {
            const me = this;
            me.ui.nextBtn.button('loading');

            me.triggerMethod('resetValidationErrors');
            const result = me.model.save(me.model.get('formAttrs'));

            if (!result) {
                return me.ui.nextBtn.button('reset');
            }

            result
                .done(function () {
                    App.execute('show:modal', new App.views.ChurnSubmittedModal());
                    RivalIQ.state.account.set({
                        selfChurned: true
                    });
                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SelfChurned);
                })
                .fail(function () {
                    me.ui.nextBtn.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        }
    });

    views.ChurnSubmittedModal = Marionette.ItemView.extend({
        template: '#accountSettingsChurnSubmittedModal',
        className: 'modal',
        attributes: {
            tabindex: -1
        },

        ui: {
            closeBtn: '.x-close-button'
        },

        events: {
            'click @ui.closeBtn': 'onClose'
        },

        onClose: function () {
            window.location.reload();
        }
    });
});
